import { createApp } from 'vue'
import App from './App.vue'
import UtilMixin from '@/mixin/UtilMixin'
import { registerPlugins } from './plugins'
import './styles/index.css'

const app = createApp(App)

// 글로벌 믹스인 등록
app.mixin(UtilMixin)

// 에러 핸들러
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue error:', err)
}

console.log('NODE ENV:', import.meta.env.MODE)

registerPlugins(app)

app.mount('#app')
